import { render, staticRenderFns } from "./uOttawa1321Prelab5Q1.vue?vue&type=template&id=7943ffe9&"
import script from "./uOttawa1321Prelab5Q1.vue?vue&type=script&lang=ts&"
export * from "./uOttawa1321Prelab5Q1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VBtnToggle,VCheckbox,VForm,VImg})
